import { css } from '@emotion/core'
import { mediumUp, largeUp } from 'Utils'
import theme from 'Theme'

const { spacing, mixins } = theme

const { mainContainerMaxWidth, mainContainerTopPadding, loadingLight } = mixins

export default () => css`
  ${mainContainerTopPadding(theme)}
  padding-bottom: ${spacing.base_3}px;
  .article-grid,
  .featured,
  .content-filter,
  .content-header-links {
    ${mainContainerMaxWidth(theme)}
    margin-bottom: ${spacing.base_3}px;
  }

  .progress {
    display: table;
    margin: 0 auto ${spacing.base_2}px auto;
  }

  .load-more-button {
    display: table;
    margin: 0 auto;
  }

  .card-loading {
    height: 260px;
    ${loadingLight(theme)}
    @media ${mediumUp} {
      height: 350px;
    }
    @media ${largeUp} {
      height: 400px;
    }
  }
`
